import { safePostAuthRedirect } from "./redirect-utils";
import type { RuntimeConfig } from "./runtime-config";

export const INVITATION_CONTINUATION_SEARCH_PARAM = "invitation_flow";

export function buildGatewayCallbackURL(
  config: RuntimeConfig,
  redirectUri?: string,
  continuationId?: string | null,
): string {
  return buildCallbackURL("/", config, redirectUri, continuationId);
}

export function buildEnrollMfaCallbackURL(
  config: RuntimeConfig,
  redirectUri?: string,
  continuationId?: string | null,
): string {
  return buildCallbackURL("/enroll-mfa", config, redirectUri, continuationId);
}

export function buildPasswordResetCallbackURL(
  config: RuntimeConfig,
  redirectUri?: string,
  continuationId?: string | null,
): string {
  return buildCallbackURL("/reset-password", config, redirectUri, continuationId);
}

function buildCallbackURL(
  path: string,
  config: RuntimeConfig,
  redirectUri?: string,
  continuationId?: string | null,
): string {
  const destination = safePostAuthRedirect(redirectUri, config);
  const params = new URLSearchParams();
  if (destination) params.set("redirect_uri", destination);
  if (continuationId) params.set(INVITATION_CONTINUATION_SEARCH_PARAM, continuationId);
  if (!params.size) return path;

  // Better Auth's relative-URL validator rejects literal '*'. URLSearchParams
  // leaves it unescaped, including in functional (not just tracking) values.
  return `${path}?${params.toString().replace(/\*/g, "%2A")}`;
}
